import { app } from '@/main'
import store from '../store'
import updateTheme from '@/mixins/update-theme'

export default function (): void {
  if (typeof app !== 'undefined') {
    app.$emit('update:loggedIn', false)
    app.$emit('update:drawer', null)
  }
  // Restore the whole in-memory store to its initial state so nothing (auth,
  // arena, cart items, selected customer, etc.) leaks into the next session.
  // Logout is an SPA navigation, so Vuex state would otherwise survive
  // logout/login. Reset before navigating so route guards see a clean store.
  store.commit('resetState')
  store.commit('cart/resetCartState')
  const preferredArena = localStorage.getItem('preferred_arena')
  localStorage.clear()
  if (preferredArena) {
    localStorage.setItem('preferred_arena', preferredArena)
  }
  app.$i18n.locale = process.env.VUE_APP_I18N_LOCALE || 'en'
  updateTheme(process.env.VUE_APP_THEME || 'Classic', app)
}
